/* eslint-disable */
import { create } from "zustand";
import { configurePersist } from "zustand-persist";
import { UserDetailModel } from "./../types/UserDetailModel";

const { persist: _persist } = configurePersist({
  storage: sessionStorage,
  rootKey: "root",
});

const persist = _persist as any;

interface Auth {
  isAuthenticated?: boolean;
  isAuthenticating?: boolean;
  errorMessage?: string;
  accessToken?: string;
  companyId?: string;
  user?: UserDetailModel;
  role?: string;
  canAccessEsop?: boolean;
}
interface AuthStore extends Auth {
  setAuth: (auth: Auth | ((auth: Auth) => Auth)) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthStore>(
  persist(
    {
      key: "auth",
    },
    (set: any) => ({
      isAuthenticated: false,
      isAuthenticating: false,
      errorMessage: "error",
      accessToken: undefined,
      companyId: undefined,
      user: undefined,
      role: undefined,
      canAccessEsop: false,
      setAuth: (auth: Auth | ((auth: Auth) => Auth)) => {
        if (typeof auth === "function") {
          set((_state: Auth) => auth(_state));
        } else {
          set((_state: Auth) => auth);
        }
      },
      clear: () => {
        set((_state: any) => ({
          isAuthenticated: false,
          isAuthenticating: false,
          errorMessage: "error",
          accessToken: undefined,
          role: undefined,
          companyId: undefined,
          user: undefined,
          canAccessEsop: false,
        }));
      },
    })
  )
);

export const getAuthStore = () => useAuthStore.getState();